import qs from 'qs';

import client from '../client';
import type {
  IDeleteModemsParams,
  IGetModemDetailsParams,
  IGetModemListExcelDownloadParams,
  IGetModemsParams,
  IModemUpsertPayload,
  IPostActivateSlackAlertParams,
  IPutModemParams,
  TUploadModemExcelParams,
} from './types';

export const modemApis = {
  getModemList: (data: IGetModemsParams) =>
    client.get(`/modems`, {
      params: data,
      paramsSerializer: {
        serialize: function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
      },
    }),
  getModemDetails: (data: IGetModemDetailsParams) => client.get(`/modems/${data.id}`),
  postModem: (data: IModemUpsertPayload) => client.post(`/modems`, data),
  putModem: (data: IPutModemParams) => client.put(`/modems/${data.id}`, data.data),
  deleteModems: (data: IDeleteModemsParams) => client.delete(`/modems?ids=${data.ids.join(',')}`),
  postActivateSlackAlert: (data: IPostActivateSlackAlertParams) => client.post(`/modems/activation/slack-alert?mac=${data.mac}`),
  getModemListExcelDownload: (params: IGetModemListExcelDownloadParams) =>
    client.get('/modems/download-list-excel', { params, responseType: 'blob' }),
  getModemRegTemplateDownload: () => client.get('/modems/download-excel', { responseType: 'blob' }),
  uploadModemExcel: (formData: TUploadModemExcelParams) =>
    client.post('/modems/upload-excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
};
